import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import Linkify from "~/components/Linkify";
import { ResizableEditableTextInput } from "~/components/ResizableEditableTextInput";
import { CUSTOM_FIELD_PLAIN_TEXT } from "~/constants/testIDs";
export const CustomFieldPlainText = /*#__PURE__*/ memo((param)=>{
    let { field, onSubmit } = param;
    if (onSubmit) {
        return /*#__PURE__*/ _jsx(ResizableEditableTextInput, {
            label: "Field value",
            placeholder: "None",
            "data-testid": "".concat(CUSTOM_FIELD_PLAIN_TEXT, "-").concat(field.name),
            defaultValue: field.plainTextValue,
            onSubmit: onSubmit,
            appearance: "outline"
        });
    }
    return /*#__PURE__*/ _jsx(Linkify, {
        children: /*#__PURE__*/ _jsx("div", {
            "data-testid": "READONLY_CUSTOM_FIELD_PLAIN_TEXT",
            "data-fieldname": field.name,
            className: "whitespace-pre-wrap break-normal px-2 py-1 text-14 leading-normal text-grey-11",
            children: field.plainTextValue || "None"
        })
    });
});
CustomFieldPlainText.displayName = "CustomFieldPlainText";
